// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'responsibleDealer',
                    value: 'Responsible Dealer'
                },
                {
                    key: 'responsibleDealerName',
                    value: 'Responsible DealerName'
                },
                {
                    key: 'branch',
                    value: 'Branch'
                },
                {
                    key: 'division',
                    value: 'Division'
                },
                {
                    key: 'invoiceDealer',
                    value: 'Invoice Dealer'
                },
                {
                    key: 'invoiceDealerName',
                    value: 'Invoice DealerName'
                },
                {
                    key: 'settlementDate',
                    value: 'Settlement Date'
                },
                {
                    key: 'invoiceNumber',
                    value: 'Invoice Number'
                },
                {
                    key: 'invoiceDate',
                    value: 'Invoice Date'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'pin',
                    order: 'DESC',
                    value: 'PIN'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/state/views.js